import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from "firebase/auth";
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from "firebase/analytics";
import { firebaseConfig as devConfig } from './config.dev.js'; // Change to config.dev.js for development
import { firebaseConfig as prodConfig } from './config.prod.js'; // Change to config.dev.js for development


// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Use environment variable to pick correct config
const isProd = process.env.NODE_ENV === "production";
const config = true ? prodConfig : devConfig;


// Initialize Firebase
const app = initializeApp(config);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Analytics must be browser-only
let analytics = null;

isSupported().then((supported) => {
    if (supported) {
        analytics = getAnalytics(app);
    }
});

export { auth, db, storage, functions, analytics };